export default {"src":"/_next/static/media/checkbox.e6ec32e9.svg","height":38,"width":38};